module.exports = __webpack_public_path__ + "img/help22.2e69be75.png";